import { t } from "@bezbolisno/i18n";

/**
 * The read model types these as plain strings (the API's own enums live in the domain), so
 * every lookup falls back to the raw key instead of rendering "undefined".
 */
const APPOINTMENT: Record<string, string | undefined> = { ...t.appointments.status };
const INVOICE: Record<string, string | undefined> = { ...t.invoices.status };
const PACKAGE: Record<string, string | undefined> = { ...t.packages.status };

export const appointmentStatus = (key: string): string => APPOINTMENT[key] ?? key;
export const invoiceStatus = (key: string): string => INVOICE[key] ?? key;
export const packageStatus = (key: string): string => PACKAGE[key] ?? key;

const dayFmt = new Intl.DateTimeFormat("uk-UA", {
  timeZone: "Europe/Kyiv",
  day: "numeric",
  month: "long",
});

/** "2 жовтня" — the clinic's local day, for an invoice row. */
export const dayLabel = (iso: string): string => dayFmt.format(new Date(iso));
